const messages = {
  ru: {
    topbar: {
      logo: "Государственное предприятие<br/> «Туркменулаггозегчилик»",
      login: "Вход",
      signup: "Регистрация",
      main_page: "Главная",
      services_page: "Услуги",
      online_application_page: "Онлайн заявление",
      news_page: "Новости",
      about_us_page: "О нас",
      contacts_page: "Контакты",
      copyright: "Все права зашищены",
      privacy_policy: "Политика конфеденциальности",
      address_value: "г. Ашхабад, пр. Арчабил, 126",
    },

    main_page: {
      banner_text: "НАДЗОР ТРАНСПОРТНЫХ СРЕДСТВ И УСЛУГ",
      online_application: "Онлайн заявка",
      about_us_sec: {
        text_1: `&nbsp;<strong>Государственное предприятие «Туркменулаггозегчилик»</strong> Министерства автомобильного транспорта Туркменистана было впервые создано в феврале 1994 года как Государственное предприятие «Туркментрансинспекция» Министерство автомобильного транспорта Туркменистана`,
        text_2: `&ensp;Компания разрабатывает и контролирует соответствующие логистические решения для эффективного
                          использования международных транспортных коридоров Туркменистана, для перевозки транзитных и
                          экспортно-импортных грузов от грузоотправителя к грузополучателю с использованием одного или нескольких
                          видов транспорта.`,
        background_text: "О <br/> НАС",
      },

      details_button: "Подробнее",
      year_motto: "«МЕЖДУНАРОДНЫЙ ГОД<br/> МИРА И ДОВЕРИЯ»",
      services_text: `&ensp;Компания разрабатывает и контролирует соответствующие логистические решения для эффективного
                        использования международных транспортных коридоров Туркменистана, для перевозки транзитных и
                        экспортно-импортных грузов от грузоотправителя к грузополучателю с использованием одного или нескольких
                        видов транспорта.`,
    },

    permissions_nav: {
      title: "РАЗРЕШЕНИЯ",
      text_1: `1. Оформление Разрешения на въезд и транзит иностранных транспортных средств по прибытии в Туркменистан.`,
      text_2: `2. Оформление разрешений на «Погрузку грузов в транспортные средства иностранных государств в Туркменистане
                                  и ввоз грузов из третьей страны в Туркменистан», предоставление транспортно-экспедиторских услуг для
                                  незарегистрированных в Туркменистане предприятий и иностранных перевозчиков.`,
    },

    services_nav: {
      title: "Услуги",
      text_1: `1. Услуги технического осмотра местных и иностранных автомобилей.`,
      text_2: `2. Услуга по выдаче таможенными контрольно-пропускными пунктами Разрешения на
                                временный пропуск иностранных прицепов и полуприцепов, въезжающих и следующих транзитом через территорию
                                Туркменистана с помощью местных тягачей.`,
      text_3: `3. Транспортно-экспедиторское обслуживание, международное экспедирование грузов.`,
      text_4: `4. Услуги по Оформлению разрешений по прибытию и транзите грузовых автомобилей иностранных государств в
                                Туркменистан и их взаимный обмен с компетентными организациями иностранных государств.`,
      text_5: `5. Услуги по повторной регистрации и контролю иностранных транспортных средств, временно въезжающих на
                                территорию Туркменистана.`,
      text_6: `6. Услуги технического осмотра автобусов (автобусы 10 летней эксплуатации).`,
    },

    calculation_supervision_nav: {
      title: "УЧЕТ И<br/> НАДЗОР",
      text_1: `1. Учет контрольно-пропускными пунктами автотранспортных средств с зарегистрированным в
                                  Туркменистане грузом, при въезде или выезде через государственную границу.`,
      text_2: `2. В соответствии с Кодексом «Об административных правонарушениях» Туркменистана предусматриваются
                                правила перевозки пассажиров, багажа, а также выявляется нарушение правил перевозки грузов,
                                применяются меры наказания и регулярное перечисление штрафов в государственный бюджет.`,
    },

    feedback_banner: {
      phone: "Телефон",
      address: "Адрес",
      address_value: "Проспект Арчябиль, 126, Ашгабат, Туркменистан",
      work_hours: "Время работы",
      work_hours_value_1: "Пн-Пт 09:00-18:00",
      work_hours_value_2: "Сб 09:00-13:00",
      contact_us: "Напишите нам",
      your_name: "Имя*",
      your_phone: "Телефон*",
      your_message: "Сообщение*",
      send_button: "Отправить",
      department: "Отдел",
      general_dep: "Общий отдел",
      technical_dep: "Технический отдел",

      success: {
        title: "Сообщение отправлено",
        message: "Ваше сообщение успешно отправлено",
        buttonText: "Хорошо",
      },
      failure: {
        title: "Сообщение не отправлено",
        message: "Произошла ошибка при отправке вашего сообщения",
        buttonText: "Хорошо",
      },
    },

    map_section: {
      title: "Контрольно-пропускные пункты на государственной границе",
      text_1: `Государственное предприятие «Туркменулаггозегчилик» Агентства «Туркменавтоулаглары» Агентства транспорта и
                  коммуникаций при Кабинете Министров Туркменистана впервые было создано в феврале 1994 года как
                  государственное предприятие Министерства автомобильного транспорта Туркменистана «Туркментрансинспекция».`,
      text_2: `Государственное предприятие «Туркменулаггозегчилик» Агентства «Туркменавтоулаглары» Агентства транспорта и
                  коммуникаций при Кабинете Министров Туркменистана впервые было создано в феврале 1994 года как
                  государственное предприятие Министерства автомобильного транспорта Туркменистана «Туркментрансинспекция».`,
      background_text: "Контрольно-пропускные пункты",
    },

    services_page: {
      description:
        "Услуги, предоставляемые Государственным предприятием «Туркменулаггозегчилик»:",
    },

    about_us_page: {
      p_1: `Государственное предприятие «Туркменулаггозегчилик» следит за удовлетворительной, стабильной и безопасной работой 
              рынка услуг, связанных с перевозками населения и отраслей экономики Туркменистана, а также способствует повышению 
              конкурентоспособности компаний, занимающихся автотранспортными услугами в стране и за её пределами, а также 
              увеличению объёмов транзитных грузов.`,

      p_2: `Государственное предприятие «Туркменулаггозегчилик» осуществляет следующие мероприятия, связанные с увеличением 
              пропускной способности международных транспортных коридоров в транспортной сфере Туркменистана, регулярной 
              организацией грузовых перевозок и организационным осуществлением этих мероприятий:`,

      li_1: `Контроль за безопасностью грузовых перевозок;`,
      li_2: `Контроль за безопасной перевозкой пассажиров и обеспечение высокой культуры их обслуживания;`,
      li_3: `Предоставление парковочных и технических услуг заинтересованным лицам и перевозчикам;`,
      li_4: `Контроль за соблюдением требований законодательства о перевозках грузов и лицензировании транспортно-экспедиторской деятельности;`,
      li_5: `Предоставление услуг по техническому осмотру транспортных средств;`,
      li_6: `Проведение проверок, оказание практической и методической помощи автомобильным предприятиям на основании поручений учредителя;`,
      li_7: `В целях компенсации затрат, связанных с осуществлением транспортного контроля, при экспортно-импортных и транзитных грузовых 
              перевозках, логистических, тарифных, технических и других вопросах, целесообразно воспользоваться льготами, предусмотренными 
              законодательством Туркменистана, а также содержать производственные, фермерские и другие хозяйства;`,
      li_8: `Рассмотрение, анализ и принятие соответствующих решений по сбору документов для регистрации транспортных средств и прицепов для 
              физических и юридических лиц, с целью проведения проверок и сертификационных мероприятий;`,
      li_9: `Контроль за соблюдением соответствующих нормативно-правовых актов согласно плану, который ежегодно утверждается трехсторонним 
              соглашением с уполномоченными предприятиями, учреждениями и организациями;`,
      li_10: `Разработка технических условий и методов оказания услуг в области регистрации, испытаний и сертификации транспортных средств, 
              допущенных к участию в дорожном движении и обеспечения безопасности дорожного движения;`,
      li_11: `Разработка обязательных правил организации и осуществления грузовых перевозок, и контроля по их соблюдению;`,
      li_12: `Разработка специальных правил дорожного движения и установка мер безопасности при их выполнении;`,
      li_13: `Сбор, обобщение и анализ информации о деятельности грузовых перевозок;`,
      li_14: `Осуществление иных полномочий в соответствии с нормативными правовыми актами Туркменистана.`,
    },

    online_application_navbar: {
      title: "Личный кабинет",

      individual: "Данные учреждения (Физ. Лицо)",
      legal: "Данные учреждения (Юр. Лицо)",
      drivers: "Водители",
      cars: "Машины",
      traits: "Прицепы",
      request_to_permit: "Заявка на Дозвол (E-permit)",

      load_permission_tab:
        "Разрешение на международную перевозку (для погрузки)",
      unload_permission_tab:
        "Разрешение на международную перевозку (для разгрузки)",
      online_application_tab: "Заявка на получение CMR",
      change_password_tab: "Поменять пароль",
      logout: "Выйти",
    },

    initial_tab: {
      title: "Онлайн заявление",
      dashboard: "Личный кабинет",
      load_permission: "Разрешение на международную перевозку (для погрузки)",
      unload_permission:
        "Разрешение на международную перевозку (для разгрузки)",
      online_application: "Заявка на получение CMR",
    },

    profile_tab: {
      profile_data: "Данные профиля",
      family_name: "Ваша фамилия и имя",
      phone: "Телефон *",
      institution_data: "Данные учреждения",
      institution_name: "Название учреждения",
      cert_id: "Номер и срок действия удостоверения",
      yegrpo:
        "Единый государственный реестр юридических лиц Туркменистана (ÝEGRPO):",
      save_button: "Сохранить",

      success: {
        title: "Данные обновлены",
        message: "Ваши данные успешно обновлены",
        buttonText: "Хорошо",
      },
      failure: {
        title: "Данные не обновлены",
        message: "Произошла ошибка при обновлении ваших данных",
        buttonText: "Хорошо",
      },
    },

    company_data: {
      individual_title: "Физическое лицо",
      surname: "Фамилия",
      name: "Имя",
      patronymic: "Отчество",
      tel: "Телефон",
      patent: "Патент",
      licenseNumb: "Номер лицензии",
      licenseCodes: "Коды лицензии",
      select_region: "Выберите велаят",
      select_city: "Выберите город",
      license_expire_date: "Дата окончания лицензии",
      patent_number: "Номер патента",
      patent_expire_date: "Дата окончания патента",
      license: "Лицензия",

      legal_title: "Юридическое лицо",
      company_name: "Название организации",
      egrepo_number: "Номер ЕГРПО (TÝŞÝDSG (EГРПО) tamamlanýan möhleti)",
      egrepo_expire_date:
        "Дата окончания ЕГРПО (TÝŞÝDSG (EГРПО) tamamlanýan möhleti)",
      sertificate_number: "Номер Сертификата (Bellige alyş nomeri)",
      address: "Юридический адрес",
      bank_info: "Банк (Bank maglumatlary)",
      bank_account_number: "Номер расчетного счета (H/h)",
      bank_balance: "Баланс расчетного счета",
      egrepo: "ЕГРПО (TÝŞÝDSG EГРПО)",
      certificate: "Сертификат",
    },

    driver_tab: {
      driver_list: "Дозвол. Водители",
      driver_add: " Добавить Водителя",
      surname: "Фамилия",
      name: "Имя",
      patronymic: "Отчество",
      driving_license_number: "Номер водительского удостоверения",
      driving_license_category: "Категория водительского удостоверения",
      driving_license_expire_date: "Дата окончания водительского удостоверения",
      transports: "Транспорты",
      trait: "Прицепы",
    },

    car_tab: {
      car_list: "Дозвол. Машины",
      car_add: "Добавить Машину",
      car_brand: "Марка машины",
      car_number: "Номер машины",

      card_number: "Номер карточки",
      card_star_date: "Дата выдачи карточки",
      select_driver: "Выберите водителя",
    },

    trailer_tab: {
      trailer_title: "Дозвол. Прицепы",
      trailer_add: "Добавить Прицеп",
      trailer_brand: "Марка прицепа",
      trailer_number: "Номер прицепа",
    },

    e_permit_tab: {
      permit_history: "История Дозвола (E-permit)",
      permit_type: "Тип поездки",
      permit_add: "Создание Заявки",
      to_country: "Страна назначения",
      departure_date: "Дата отъезда",
      return_date: "Дата возврата",
      status: "Статус",
      payment: "Оплата",
      statusType: {
        1: "Новый",
        2: "На рассмотрении",
        3: "К оплате",
        4: "Оплачено",
        5: "Успешно",
        6: "Отклонено",
      },

      car: "Машина",
      trailer: "Прицеп",
      individual: "Физическое лицо",
      legal: "Юридическое лицо",
      select_country: "Выберите страну назначения",
      type_of_cargo: "Тип груза",
      container_number: "Количество контейнеров",
      select_car: "Выберите машину",
      select_trailer: "Выберите прицеп",
    },

    load_permission_tab: {
      title: "Разрешение на международную перевозку <br/>(для погрузки)",
      permission_id: "Разрешения №",
      car_brand: "Марка автотранспортного средства",
      transporter_name: "Фамилия, имя, отчество перевозчика",
      unloading_point: "Пункт выгрузки автотранспортного средства",
      cargo_type: "Наименование и вес груза",
      applicant_name: "Наименование заявителя",
      permission_issued: "Место выдачи и дата",
      car_state_affiliation:
        "Государственная принадлежность автотранспортного средства",
      car_state_id: "Государственный № автотранспортного средства",
      loading_point: "Пункт погрузки автотранспортного средства",
      cargo_route: "Маршрут следования груза",
      cargo_ownership: "Принадлежность груза",
      expiration_date: "Срок действия разрешения",
      cmr_id: "CMR №",
      save_button: "Сохранить",

      success: {
        title: "Спасибо",
        message: "Ваша заявка принята. Наши администраторы свяжутся с вами.",
        buttonText: "OK",
      },
      failure: {
        title: "Ошибка",
        message: "Произошла ошибка",
        buttonText: "OK",
      },
    },

    unload_permission_tab: {
      title: "Разрешение на международную перевозку<br/> (для разгрузки)",
    },

    online_application_tab: {
      online_application: "Онлайн заявление",
      institution_name: "Наименование учреждения",
      load_permission_id:
        "Номер разрешения на погрузку на территории Туркменистана",
      cmr_id: "Автодорожная накладная CMR (штук)",
      submit_button: "Подтвердить",

      responsible: {
        title: "Ответственный сотрудник",
        name: "Фамилия и имя ответственного сотрудника:",
        phone: "Телефон ответственного сотрудника:",
        email: "E-mail ответственного сотрудника:",
        director_name: "Фамилия и имя директора учреждения:",
      },

      additional_notes: {
        title: "Сопроводительные письма",
        file_1_desc: "Загрузите копию заявления",
        file_2_desc: `Загрузить копию лицензии на организацию перевозки грузов автомобильным транспортом, 
                        осуществление деятельности по экспедированию грузов (перевозок) на основании подвида 
                        «Транспортно - экспедиторская деятельность» - 52.29.22`,
        file_3_desc:
          "Единый государственный реестр юридических лиц Туркменистана",
        attach_file: "Прикрепить файл",
      },

      video: {
        title: "Посмотрите видео ниже, чтобы узнать, как подать онлайн-заявку",
        watch_button: "Просмотреть видео",
      },

      pdf: {
        title: "Скачать копию заявления",
        download_button: "Скачать PDF",
      },

      success: {
        title: "Спасибо",
        message: "Ваша заявка принята. Наши администраторы свяжутся с вами.",
        buttonText: "Хорошо",
      },
      failure: {
        title: "Ошибка",
        message: "Произошла ошибка",
        buttonText: "Хорошо",
      },
      unsupportedFormat: {
        title: "Ошибка",
        message: "Данный формат файла не поддерживается",
        buttonText: "Хорошо",
      },

      fileSizeExceeded: {
        title: "Ошибка",
        message: "Слишком большой файл",
        buttonText: "Хорошо",
      },
    },

    history_tab: {
      title: "История заявок",
      permission_number: "Разрешение №",
      date: "Дата",
      type: "Заявка",
      status: "Статус",
      cancel: "Отменить",
      pending: "На рассмотрении",
      accepted: "Принято",
      declined: "Отказано",
      canceled: "Отменено",
      driver_name: "ФИО Водителя",

      success: {
        title: "Данные обновлены",
        message: "Ваши данные успешно обновлены",
        buttonText: "Хорошо",
      },
      failure: {
        title: "Данные не обновлены",
        message: "Произошла ошибка при обновлении ваших данных",
        buttonText: "Хорошо",
      },
    },

    change_password_tab: {
      title: "Смена пароля",
      old_password: "Старый пароль",
      new_password: "Пароль",
      password_confirmation: "Подтверждение пароля",
      submit_button: "Подтвердить",
    },

    single_news_page: {
      similar_news: "Похожие новости",
    },

    login_page: {
      title: "Вход",
      password: "Пароль",
      no_account: "Нет аккаунта?",
      signup: "Зарегистрируйтесь",
      submit_button: "Войти",
      forgot_password: "Забыли пароль?",
      invalid_creds: "Неверные данные",
    },

    signup_page: {
      title: "Регистрация",
      responsible_empl: "Ответственный сотрудник",
      name: "Фамилия и имя",
      phone: "Телефон",
      accept_privacy_policy1: "Я принимаю условия",
      accept_privacy_policy2: "Политики конфиденциальности",
      institution_name: "Наименование учреждения",
      cert_id: "Номер и срок действия удостоверения",
      yegrpo:
        "Единый государственный реестр юридических лиц Туркменистана (ÝEGRPO):",
      submit_button: "Регистрация",

      confirmation_tab: {
        message_sent:
          "На указанную вами почту было отправлено письмо с кодом подтверждения",
        conf_number: "Код подтверждения",
        submit_button: "Ввести",
      },

      password_tab: {
        title: "Регистрация",
        password: "Пароль",
        password_conf: "Подтверждение пароля",
        submit_button: "Сохранить",
      },

      success: {
        title: "Пользователь создан",
        message: "Новый пользователь создан успешно",
        buttonText: "Хорошо",
      },
      failure: {
        title: "Ошибка",
        message: "Произошла ошибка",
        buttonText: "Хорошо",
      },
    },

    reset_page: {
      title: "Сброс пароля",

      tab_1: {
        title: "Введите Email",
        confirm: "Подтвердить",
        info_text:
          "На указанную вами почту было отправлено письмо с ссылкой на сброс пароля",
      },
      tab_2: {
        title: "Смена пароля",
        new_password: "Новый пароль",
        password_conf: "Подтвердите пароль",
        confirm: "Подтвердить",
      },

      failure: {
        title: "Ошибка",
        message: "Произошла ошибка, проверьте ваши данные",
        invalid_link: "Ссылка недействительна",
        buttonText: "Хорошо",
      },

      success: {
        title: "Пароль обновлен",
        message: "Ваш пароль успешно обновлен",
        buttonText: "OK",
      },
    },

    not_found_page: {
      title: "404 Страница Не Найдена",
    },
  },

  tm: {
    topbar: {
      logo: "«TÜRKMENULAGGÖZEGÇILIK»<br/> DÖWLET KÄRHANASY",
      login: "Girmek",
      signup: "Registrasiýa",
      main_page: "Baş sahypa",
      services_page: "Hyzmatlar",
      online_application_page: "Onlaýn hyzmatlar",
      news_page: "Habarlar",
      about_us_page: "Biz barada",
      contacts_page: "Habarlaşmak üçin",
      copyright: "Ähli hukuklary goralan",
      privacy_policy: "Gizlinlik syýasaty",
      address_value: "Aşgabat ş., Arçabil şaýoly, 126",
    },

    main_page: {
      banner_text: "ULAG SERIŞDELERINIŇ WE HYZMATLARYNYŇ GÖZEGÇILIGI",
      online_application: "Onlaýn ýüztutma",
      about_us_sec: {
        text_1: `&nbsp;Türkmenistanyň Awtomobil ulaglary ministirliginiň <strong>«Türkmenulaggözegçilik» döwlet kärhanasy</strong> ilkinji gezek 1994-nji ýylyň fewralynda Türkmenistanyň Awtomobil transporty ministrliginiň «Türkmentransinspeksiýa» döwlet kärhanasy hökmünde döredildi.`,
        text_2: `&ensp;Kärhana Türkmenistanyň halkara ulag-üstaşyr geçelgeleriniň mümkinçiliklerini
                          netijeli ulanmakda, üstaşyr we eksport-import ýüklerini ýük ugradyjydan bir ýa-da birnäçe
                          ulag görnüşleri arkaly ýük alyja eltmekde ýerlikli logistiki çözgütleri işläp düzýär we bu
                          işleriň amala aşyrylmagyna gözegçilik edýär.`,
        background_text: "BIZ <br/> BARADA",
      },

      details_button: "Giňişleýin",
      year_motto: "«Halkara Parahatçylyk<br/> we Ynanyşmak ýyly»",
      services_text: `&ensp;Kärhana Türkmenistanyň halkara ulag-üstaşyr geçelgeleriniň mümkinçiliklerini netijeli
                        ulanmakda, üstaşyr we eksport-import ýüklerini ýük ugradyjydan bir ýa-da birnäçe ulag görnüşleri
                        arkaly ýük alyja eltmekde ýerlikli logistiki çözgütleri işläp düzýär we bu işleriň amala aşyrylmagyna
                        gözegçilik edýär.`,
    },

    permissions_nav: {
      title: "RUGSATLAR",
      text_1: `1. Daşary ýurt awtoulag serişdeleri Türkmenistana gelende we üstaşyr geçende Rugsatnamany resmileşdirmek.`,
      text_2: `2. Türkmenistanda resmileşdirilmedik kärhanalar we daşary ýurtly gatnadyjylar üçin Türkmenistanyň çäginde
                «Daşary ýurt döwletleriniň awtoulag serişdelerine Türkmenistanda ýük ýüklemek we Türkmenistana üçünji
                döwletden ýük getirmeklige» rugsatnama resmileşdirmek boýunça ulag-ekspeditorçylyk hyzmatlary.`,
    },

    services_nav: {
      title: "Hyzmatlar",
      text_1: `1. Türkmen we daşary ýurt awtoulaglarynyň tehniki ýagdaýyny gözden geçirmek hyzmaty.`,
      text_2: `2. Türkmenistanyň çägine girýän we üstaşyr geçýän daşary ýurt tirkegleri we ýarym
                      tirkegleri gümrük gözegçilik-geçiriş ýerlerinden ýerli eýerli çekijide Türkmenistanyň
                      çägine wagtlaýyn goýbermek üçin Rugsatnamanyň berilmegi üçin hyzmat.`,
      text_3: `3. Ulag-ekspeditorçylyk hyzmaty, halkara daşalýan ýüküň ýanhatyny goýbermek.`,
      text_4: `4. Daşary ýurt döwletleriniň ýük awtoulag serişdeleriniň Türkmenistana gelmegi we
                    onuň çäginden üstaşyr geçmegi üçin berilýän we daşary ýurt döwletleriniň ygtyýarly
                    guramalary bilen özara alşylýan Rugsatnamalary resmileşdirmek hyzmaty.`,
      text_5: `5. Türkmenistanyň çägine wagtlaýyn giren daşary ýurt awtoulag serişdelerini
                    gaýtadan hasaba almak we gözegçilikde saklamak üçin ýerine ýetirilýän hyzmat.`,
      text_6: `6. Awtoulaglary tehniki gözegçilikden geçirmek hyzmaty (10 ýyl bolan awtobuslar).`,
    },

    calculation_supervision_nav: {
      title: "HASAP WE<br/> GÖZEGÇILIK",
      text_1: `1. Türkmenistanyň döwlet serhediniň üstünden geçilýän awtoýol gözegçilik-geçiriş
                    ýerlerinden Türkmenistanyň çägine girýän we onuň çäginden çykýan Türkmenistanda hasaba
                    alnan ýük awtoulag serişdelerini bellige almak.`,
      text_2: `2. Türkmenistanyň «Administratiw hukuk bozulmalary hakynda» Kodeksine laýyklykda,
                    ýolagçylary, goşlary awtoulagda daşamagyň düzgünleri, ýükleri awtoulagda daşamagyň
                    düzgünleriniň bozulmalaryny ýüze çykarmak, temmi çärelerini ulanmak we jerimeleri döwlet
                    býujetine yzygiderli ugratmak amallary.`,
    },

    feedback_banner: {
      phone: "Telefon",
      address: "Salgymyz",
      address_value: "Arçabil şaýoly, 126, Aşgabat, Türkmenistan",
      work_hours: "Iş wagtymyz",
      work_hours_value_1: "Du-An 09:00-18:00",
      work_hours_value_2: "Şn 09:00-13:00",
      contact_us: "Bize hat ýazyň",
      your_name: "Adyňyz*",
      your_phone: "Telefon belgiňiz*",
      your_message: "Siziň hatyňyz*",
      send_button: "Ibermek",
      department: "Bölüm",
      general_dep: "Umumy bölüm",
      technical_dep: "Tehniki bölüm",

      success: {
        title: "Hatyňyz iberildi",
        message: "Siziň hatyňyz üstünlikli iberildi",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Hatyňyz iberilmedi",
        message: "Siziň hatyňyz ýüze çykan ýalňyşlyk sebäpli iberilmedi",
        buttonText: "Bolýa",
      },
    },

    map_section: {
      title: "Döwlet serhedindäki gözegçilik-geçiriş ýerleri",
      text_1: `Türkmenistanyň Ministrler Kabinetiniň ýanyndaky ulag we kommunikasiýalar agentliginiň «Türkmenawtoulaglary»
                  agentliginiň «Türkmenulaggözegçilik» döwlet kärhanasy ilkinji gezek 1994-nji ýylyň fewralynda Türkmenistanyň
                  Awtomobil transporty ministrliginiň «Türkmentransinspeksiýa» döwlet kärhanasy hökmünde döredildi.`,
      text_2: `Türkmenistanyň Ministrler Kabinetiniň ýanyndaky ulag we kommunikasiýalar agentliginiň «Türkmenawtoulaglary»
                agentliginiň «Türkmenulaggözegçilik» döwlet kärhanasy ilkinji gezek 1994-nji ýylyň fewralynda Türkmenistanyň
                Awtomobil transporty ministrliginiň «Türkmentransinspeksiýa» döwlet kärhanasy hökmünde döredildi.`,
      background_text: "Gözegçilik-geçiriş ýerleri",
    },

    services_page: {
      description:
        "«Türkmenulaggözegçilik» döwlet kärhanasy tarapyndan hödürlenilýän hyzmatlar:",
    },

    about_us_page: {
      p_1: `&emsp;«Türkmenulaggözegçilik» döwlet kärhanasy Türkmenistanyň ilatyny we ykdysadyýetiniň pudaklaryny awtoulagda daşamak 
              bilen bagly hyzmatlar bazarynyň kanagatlanarly, durnukly hem-de howpsuz işlemegine gözegçilik etmek bilen bir 
              hatarda ýurdumyzyň çäginde we onuň daşynda awtoulag hyzmatlaryny amala aşyrýan kärhanalaryň dünýä derejesinde 
              bäsdeşlige ukyplylygynyň ýokarlandyrylmagyna, üstaşyr ýükleriň möçberiniň artdyrylmagyna ýardam berýär.`,

      p_2: `&emsp;“Türkmenulaggözegçilk” döwlet kärhanasy Türkmenistanyň ulag ulgamynda halkara ulag-üstaşyr geçelgeleriniň 
              mümkinçilikleriniň artdyrylmagy, ulaglar arkaly ýük gatnawlaryny kadaly guramak hem-de bu işleriň guramaçylykly 
              amala aşyrylmagy bilen baglanyşykly şu işleri ýerine ýetirýär:`,

      li_1: `Awtoulaglarda ýük daşamagyň howpsuzlygyna gözegçilik etmek;`,
      li_2: `Awtoulaglarda ýolagçylaryň howpsuz gatnadylmagyna we olara hyzmat etmegiň ýokary medeniýetiniň üpjün edilmegine gözegçilik etmek;`,
      li_3: `Isleg bildiren taraplara, daşaýjylara duralga hyzmatlaryny hödürlemek we tehniki hyzmatlary amala aşyrmak;`,
      li_4: `Awtoulagda ýük daşamak we ulag-ekspedisiýa işiniň ygtyýarlandyrylmagy babatdaky kanunçylygyň talaplarynyň ýerine ýetirilişine gözegçilik etmek;`,
      li_5: `Awtoulag serişdelerini tehniki taýdan gözden geçiriş hyzmatlaryny etmek;`,
      li_6: `Esaslandyryjynyň görkezmesi esasynda awtoulag kärhanalarynda gözegçilik tertibinde barlaglary geçirmek, tejribe we usuly kömegi bermek;`,
      li_7: `Ulag gözegçiligini amala aşyrmak bilen bagly çykdajylaryň öwezini dolmak maksady bilen, eksport-import we üstaşyr ýük gatnawlaryny amala 
              aşyrmakda, logistika, tarif, tehniki we beýleki meseleleri çözmekde Türkmenistanyň kanunçylygynda göz öňüne tutulan ýeňilliklerden 
              peýdalanmak, önümçilik, daýhan we beýleki hojalyklary saklamak;`,
      li_8: `Fiziki we ýuridiki şahslaryň ulag serişdelerini we olaryň tirkeglerini bellige almak, synag barlagyndan geçirmek we güwälendirmek bilen 
              baglanyşykly işleri geçirmek üçin toplanan resminamalara seretmek, seljermek hem-de degişli çözgütleri çykarmak;`,
      li_9: `Her ýylda ygtyýarly kärhanalar, edaralar we guramalar bilen bilelikde üçtaraplaýyn ylalaşmak bilen tassyklanan meýilnama laýyklykda, 
              degişliligi boýunça kanunlaryň, kadalaşdyryjy hukuk namalarynyň talaplarynyň berjaý edilişine gözegçilik etmek;`,
      li_10: `Ýol hereketine gatnaşmaga goýberilen ulag serişdelerini bellige almagyň, synag barlagyndan geçirmegiň we güwälendirmegiň hem-de ýol 
              hereketiniň howpsuzlygyny üpjün etmek çygrynda hyzmatlaryň tehniki şertlerini we usulyýetini işläp düzmek;`,
      li_11: `Ulag arkaly ýük daşamagy guramakda we amala aşyrmakda hökmany kadalary işläp düzmek, olaryň berjaý edilişiniň monitoringini amala aşyrmak;`,
      li_12: `Ýol arkaly daşaýyş çygrynda ýörite düzgünleri işläp düzmek we olar amala aşyrylanda howpsuzlyk çärelerini bellemek;`,
      li_13: `Awtoulag serişdesinde ýükleri daşamak boýunça işler baradaky maglumatlary toplamak, jemlemek we seljermek;`,
      li_14: `Türkmenistanyň kadalaşdyryjy hukuk namalaryna laýyklykda beýleki ygtyýarlyklary amala aşyrmak.`,
    },

    online_application_navbar: {
      title: "Şahsy otag",

      individual: "Fiziki şahs",
      legal: "Ýuridiki şahs",
      drivers: "Sürüjiler",
      cars: "Awtoulaglar",
      traits: "Tirkegler",
      request_to_permit: "Rugsatnama (E-permit) sargytlary",

      load_permission_tab:
        "Halkara daşaljak ýüküň rugsatnamasy (ýüklemek üçin)",
      unload_permission_tab:
        "Halkara daşaljak ýüküň rugsatnamasy (düşürmek üçin)",
      online_application_tab: "CMR almak üçin ýüztutma",
      change_password_tab: "Paroly üýtgetmek",
      logout: "Çykmak",
    },

    initial_tab: {
      title: "Onlaýn hyzmatlar",
      dashboard: "Şahsy otag",
      load_permission: "Halkara daşaljak ýüküň rugsatnamasy (ýüklemek üçin)",
      unload_permission: "Halkara daşaljak ýüküň rugsatnamasy (düşürmek üçin)",
      online_application: "CMR almak üçin ýüztutma",
    },

    profile_tab: {
      profile_data: "Profil maglumatlary",
      family_name: "Familiýaňyz we adyňyz",
      phone: "Telefon *",
      institution_data: "Edara maglumatlary",
      institution_name: "Edaranyň ady",
      cert_id: "Ygtyýarnama belgisi we möhleti",
      yegrpo: "Türkmenistanyň ýuridik şahslarynyň ýeke-täk döwlet sanawy:",
      save_button: "Saklamak",

      success: {
        title: "Maglumatlar üýtgedildi",
        message: "Siziň maglumatlaryňyz üstünlikli üýtgedildi",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Maglumatlar üýtgedilmedi",
        message:
          "Siziň maglumatlaryňyz ýüze çykan ýalňyşlyk sebäpli üýtgedilmedi",
        buttonText: "Bolýa",
      },
    },

    company_data: {
      individual_title: "Fiziki şahs",
      surname: "Familiýa",
      name: "Ady",
      patronymic: "Atasynyň ady",
      tel: "Telefon",
      patent: "Patent",
      licenseNumb: "Ygtyýarnama nomeri",
      licenseCodes: "Ygtyýarnama kody",
      select_region: "Welaýaty saýlaň:",
      select_city: "Şäheri saýlaň:",
      license_expire_date: "Ygtyýarnamanyň gutarýan senesi",
      patent_number: "Patent nomeri",
      patent_expire_date: "Patentiň gutarýan senesi",
      license: "Ygtyýarnama",

      legal_title: "Ýuridiki şahs",
      company_name: "Hojalyk eýeçiliginiň ady",
      egrepo_number: "ÝŞÝDS(ЕГРПО) nomeri",
      egrepo_expire_date: "ÝŞÝDS(ЕГРПО) gutarýan senesi",
      sertificate_number: "Sertifikat nomeri",
      address: "Hukuk salgysy",
      bank_info: "Bank maglumatlary",
      bank_account_number: "Hasaplaşyk hasabynyň (H/h) nomeri",
      bank_balance: "Hasaplaşyk hasabynyň balansy",
      egrepo: "ÝŞÝDS(ЕГРПО)",
      certificate: "Sertifikat",
    },

    driver_tab: {
      driver_list: "Sürüjileriň maglumatlary",
      driver_add: " Sürüjini goş",
      surname: "Familiýa",
      name: "Ady",
      patronymic: "Atasynyň ady",
      driving_license_number: "Sürüji şahadatnamasynyň nomeri",
      driving_license_category: "Sürüji şahadatnamasynyň kategoriýasy",
      driving_license_expire_date: "Sürüji şahadatnamasynyň möhleti",
      transports: "Awtoulaglar",
      trait: "Tirkegler",
    },

    car_tab: {
      car_list: "Awtoulaglaryň maglumatlary",
      car_add: "Awtoulagy goş",
      car_brand: "Awtoulag markasy",
      car_number: "Awtoulag nomeri",

      card_number: "Kartoçkanyň nomeri",
      card_star_date: "Kartoçkanyň beriliş senesi",
      select_driver: "Sürüjini saýlaň",
    },

    trailer_tab: {
      trailer_title: "Tirkegleriň maglumatlary",
      trailer_add: "Tirkegi goş",
      trailer_brand: "Tirkegiň markasy",
      trailer_number: "Tirkegiň nomeri",
    },

    e_permit_tab: {
      permit_history: "Rusatnama (E-permit) taryhy",
      permit_type: "Ugruň görnüşi",
      permit_add: "Sargydy döret",
      to_country: "Gidiş ýurdy",
      departure_date: "Gidiş senesi",
      return_date: "Gaýdyş senesi",
      status: "Status",
      payment: "Töleg",
      statusType: {
        1: "Täze",
        2: "Seredilýär",
        3: "Tölegde",
        4: "Tölendi",
        5: "Üstünlikli",
        6: "Gaýtaryldy",
      },

      car: "Awtoulag",
      trailer: "Tirkegi",
      individual: "Fiziki şahs",
      legal: "Ýuridiki şahs",
      select_country: "Gidiş ýurduny saýlaň",
      type_of_cargo: "Ýük görnüşi",
      container_number: "Konteýnerleriň sany",
      select_car: "Awtoulag saýlaň",
      select_trailer: "Trailer saýlaň",
    },

    load_permission_tab: {
      title: "HALKARA DAŞALJAK ÝÜKÜŇ RUGSATNAMASY <br/>(ÝÜKLEMEK ÜÇIN)",
      permission_id: "Rugsatnama №",
      car_brand: "Awtoulag serişdesiniň markasy",
      transporter_name: "Sürüjiniň familiýasy, ady we atasynyň ady",
      unloading_point: "Awtoulag serişdesiniň ýüki düşürmeli nokady",
      cargo_type: "Ýüküň görnüşi we agramy",
      applicant_name: "Arza beriji",
      permission_issued: "Rugsatnamanyň berlen ýeri we wagty",
      car_state_affiliation: "Awtoulag serişdesiniň döwlet degişliligi",
      car_state_id: "Awtoulag serişdesiniň döwlet belgisi",
      loading_point: "Awtoulag serişdesiniň ýük ýüklemeli nokady",
      cargo_route: "Ýüküň gitmeli ugry",
      cargo_ownership: "Ýüküň degişliligi",
      expiration_date: "Rugsatnamanyň hereket ediş möhleti",
      cmr_id: "CMR №",
      save_button: "Saklamak",

      success: {
        title: "Sag boluň",
        message:
          "Siziň ýüztutmaňyz kabul edildi. Administratorlarymyz siz bilen habarlaşarlar.",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Ýalňyşlyk",
        message: "Ýalňyşlyk ýüze çykdy",
        buttonText: "Bolýa",
      },
    },

    unload_permission_tab: {
      title: "HALKARA DAŞALJAK ÝÜKÜŇ RUGSATNAMASY <br/>(DÜŞÜRMEK ÜÇIN)",
    },

    online_application_tab: {
      online_application: "Onlaýn ýüztutma",
      institution_name: "Edaranyň ady",
      load_permission_id:
        "Türkmenistanyň çäginde ýük ýüklemek rugsatnamasynyň sany",
      cmr_id: "Halkara daşaljak ýüküň ýanhatynyň (CMR) sany",
      submit_button: "Tassyklamak",

      responsible: {
        title: "Jogapkär işgär",
        name: "Jogapkär işgär Familiýasy we ady:",
        phone: "Jogapkär işgär Telefon belgisi:",
        email: "Jogapkär işgär E-mail:",
        director_name: "Edaranyň direktory Familiýasy we ady:",
      },

      additional_notes: {
        title: "Goşmaça hatlar",
        file_1_desc: "Ýüz tutma hatynyň göçürmesini ýükläň",
        file_2_desc: `«Ulag – ekspedisiýa işiniň» - 52.29.22 kiçi görnüşi esasynda «Awtomobil ulaglary 
                        arkaly ýük daşamagy guramak, ýükleri ekspedisiýa etmek (ýany bilen gitmek) işi» üçin 
                        hereket edýän ygtyýarnamanyň nusgasyny ýükläň`,
        file_3_desc:
          "Türkmenistanyň ýuridik şahslarynyň ýeke-täk döwlet sanawy",
        attach_file: "Faýl berkitmek",
      },

      video: {
        title:
          "Onlaýn ýüztutmany nädip ugratmalygy bilen tanyşmak üçin aşakdaky wideony görüň",
        watch_button: "Wideony görmek",
      },

      pdf: {
        title: "Ýüz tutma hatynyň göçürmesini ýükläp almak",
        download_button: "PDF ýükläp almak",
      },

      success: {
        title: "Sag boluň",
        message:
          "Siziň ýüztutmaňyz kabul edildi. Administratorlarymyz siz bilen habarlaşarlar.",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Ýalňyşlyk",
        message: "Ýalňyşlyk ýüze çykdy",
        buttonText: "Bolýa",
      },
      unsupportedFormat: {
        title: "Ýalňyşlyk",
        message: "Saýlan faýlyňyzyň formaty goldanmaýar",
        buttonText: "Bolýa",
      },

      fileSizeExceeded: {
        title: "Ýalňyşlyk",
        message: "Saýlan faýlyňyzyň göwrümi gaty uly",
        buttonText: "Bolýa",
      },
    },

    history_tab: {
      title: "Ýüztutmalaryň taryhy",
      permission_number: "Rugsatnama №",
      date: "Senesi",
      type: "Ýüztutma",
      status: "Ýagdaýy",
      cancel: "Ýatyrmak",
      pending: "Garaşylýar",
      accepted: "Kabul edildi",
      declined: "Ret edildi",
      canceled: "Ýatyryldy",
      driver_name: "Sürüjiniň FAA",

      success: {
        title: "Maglumatlar üýtgedildi",
        message: "Siziň maglumatlaryňyz üstünlikli üýtgedildi",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Maglumatlar üýtgedilmedi",
        message:
          "Siziň maglumatlaryňyz ýüze çykan ýalňyşlyk sebäpli üýtgedilmedi",
        buttonText: "Bolýa",
      },
    },

    change_password_tab: {
      title: "Paroly üýtgetmek",
      old_password: "Köne parol",
      new_password: "Parol",
      password_confirmation: "Paroly tassyklaň",
      submit_button: "Tassyklamak",
    },

    single_news_page: {
      similar_news: "Meňzeş habarlar",
    },

    login_page: {
      title: "Giriň",
      password: "Parol",
      no_account: "Akkauntyňyz ýokmy?",
      signup: "Ýazga duruň",
      submit_button: "Girmek",
      forgot_password: "Parolyňyzy unutduňyzmy?",
      invalid_creds: "Nädögry maglumat",
    },

    signup_page: {
      title: "Registrasiýa",
      responsible_empl: "Jogapkär işgär",
      name: "Familiýaňyz we adyňyz",
      phone: "Telefon",
      accept_privacy_policy1: "Men şahsy maglumatlarymy bermäge razy",
      accept_privacy_policy2: "Gizlinlik syýasaty",
      institution_name: "Edaranyň ady",
      cert_id: "Ygtyýarnama belgisi we möhleti",
      yegrpo:
        "Türkmenistanyň ýuridik şahslarynyň ýeke-täk döwlet sanawy (ÝEGRPO):",
      submit_button: "Registrasiýa",

      confirmation_tab: {
        message_sent:
          "Tassyklama kody siziň görkezen e-poçta salgyňyza iberildi",
        conf_number: "Tassyklama kody",
        submit_button: "Girizmek",
      },

      password_tab: {
        title: "Registrasiýa",
        password: "Parol",
        password_conf: "Paroly tassyklaň",
        submit_button: "Saklamak",
      },

      success: {
        title: "Ulanyjy döredildi",
        message: "Täze ulanyjy üstünlikli döredildi",
        buttonText: "Bolýa",
      },
      failure: {
        title: "Ýalňyşlyk",
        message: "Ýalňyşlyk ýüze çykdy",
        buttonText: "Bolýa",
      },
    },

    reset_page: {
      title: "Paroly täzelemek",

      tab_1: {
        title: "Poçtaňyzy giriziň",
        confirm: "Tassyklamak",
        info_text:
          "Siziň girizen salgyňyza parolyňyzy täzelemek sahypasyna ýollanma iberildi",
      },
      tab_2: {
        title: "Paroly üýtgetmek",
        new_password: "Täze parol",
        password_conf: "Paroly tassyklaň",
        confirm: "Tassyklamak",
      },

      failure: {
        title: "Ýalňyşlyk",
        message: "Ýalňyşlyk ýüze çykdy, maglumatlaryňyzy barlaň",
        invalid_link: "Bu ýollanmanyň möhleti gutardy",
        buttonText: "Bolýa",
      },

      success: {
        title: "Parol täzelendi",
        message: "Siziň parolyňyz üstünlikli täzelendi",
        buttonText: "Bolýa",
      },
    },

    not_found_page: {
      title: "404 Sahypa Tapylmady",
    },
  },

  en: {
    topbar: {
      logo: 'The state enterprise <br/>"Turkmenulaggozegchilik"',
      login: "Login",
      signup: "Register",
      main_page: "Homepage",
      services_page: "Services",
      online_application_page: "Online request",
      news_page: "News",
      about_us_page: "About Us",
      contacts_page: "Contacts",
      copyright: "All rights reserved",
      privacy_policy: "Privacy policy",
      address_value: "Ashgabat, Archabil avenue, 126",
    },

    main_page: {
      banner_text: "SUPERVISION OF VEHICLES AND SERVICES",
      online_application: "Online application",
      about_us_sec: {
        text_1: `&nbsp;<strong>The State Enterprise "Turkmenulaggozegchilik"</strong> of the Ministry of Automobile Transport of Turkmenistan was first established in February 1994 as the State Enterprise "Turkmentransinspeksiya" of the Ministry of Automobile Transport of Turkmenistan.`,
        text_2: `&ensp;For the effective use of the international transport corridors of Turkmenistan, for the
                            transportation of transit and export-import cargo from the consignor to the consignee using
                            one or more modes of transport the company develops and controls appropriate logistics solutions.`,
        background_text: "ABOUT <br/> US",
      },
      details_button: "Details",
      year_motto: "«INTERNATIONAL YEAR<br/> OF PEACE AND TRUST»",
      services_text: `&ensp;For the effective use of the international transport corridors of Turkmenistan, for the
                        transportation of transit and export-import cargo from the consignor to the consignee using one
                        or more modes of transport the company develops and controls appropriate logistics solutions.`,
    },

    permissions_nav: {
      title: "PERMISSIONS",
      text_1: `1. Registration of a Permit for the entry and transit of foreign vehicles upon arrival in Turkmenistan.`,
      text_2: `2. Registration of permits for "Loading goods into vehicles of foreign countries in Turkmenistan
                                and importing goods from a third country to Turkmenistan", providing transport and forwarding services
                                for enterprises and foreign carriers not registered in Turkmenistan.`,
    },

    services_nav: {
      title: "Services",
      text_1: `1. Technical inspection services for local and foreign cars.`,
      text_2: `2. Service for the issuance by customs checkpoints of Permits for the temporary passage of foreign
                              trailers and semi-trailers entering and transiting through the territory of Turkmenistan with the
                              help of local tractors.`,
      text_3: `3. Transport and forwarding services, international freight forwarding.`,
      text_4: `4. Services for issuing permits upon arrival and transit of trucks of foreign states to Turkmenistan and
                                their mutual exchange with competent organizations of foreign states.`,
      text_5: `5. Services for reregistration and control of foreign vehicles, temporarily entering the
                                territory of Turkmenistan.`,
      text_6: `6. Services of technical inspection of buses (buses of 10 years of operation).`,
    },

    calculation_supervision_nav: {
      title: "ACCOUNTING AND<br/> SUPERVISION",
      text_1: `1. Registration by checkpoints of vehicles with cargo registered in Turkmenistan, at the entrance
                                or exit through the state border.`,
      text_2: `2. In accordance with the Code “Of Administrative Offenses” of Turkmenistan rules for the transportation 
                              of passengers and baggage are provided, and also violations of the rules for the transportation of goods 
                              are detected, penalties are applied and fines are regularly transferred to the state budget.`,
    },

    feedback_banner: {
      phone: "Phone",
      address: "Address",
      address_value: "Archabil highway, 126, Ashgabat, Turkmenistan",
      work_hours: "Working hours",
      work_hours_value_1: "Mon-Fri 09:00-18:00",
      work_hours_value_2: "Sat 09:00-13:00",
      contact_us: "Contact us",
      your_name: "Name*",
      your_phone: "Phone*",
      your_message: "Message*",
      send_button: "Send",
      department: "Department",
      general_dep: "General department",
      technical_dep: "Technical department",

      success: {
        title: "Message sent",
        message: "Your message has been sent successfully",
        buttonText: "OK",
      },
      failure: {
        title: "Message not sent",
        message: "Error occured while sending your message",
        buttonText: "OK",
      },
    },

    map_section: {
      title: "Checkpoints at the state border",
      text_1: `The state enterprise "Turkmenulaggozegchilik" of the Agency "Turkmenawtoulaglary" of the Agency for
                  Transport and Communications under the Cabinet of Ministers of Turkmenistan was first established
                  in February 1994 as a state enterprise of the Ministry of Road Transport of Turkmenistan "Turkmentransinspeksiya".`,
      text_2: `The state enterprise "Turkmenulaggozegchilik" of the Agency "Turkmenawtoulaglary" of the Agency for
                  Transport and Communications under the Cabinet of Ministers of Turkmenistan was first established
                  in February 1994 as a state enterprise of the Ministry of Road Transport of Turkmenistan "Turkmentransinspeksiya".`,
      background_text: "Checkpoints",
    },

    services_page: {
      description:
        'Services provided by the State Enterprise "Turkmenulaggozegchilik":',
    },

    about_us_page: {
      p_1: `The state enterprise "Turkmenulaggozegchilik" monitors the satisfactory, stable and safe operation of the market 
              for services, related to the transportation of the population and sectors of the economy of Turkmenistan, and also 
              contributes to increasing the competitiveness of companies, engaged in motor transport services in the country and 
              abroad, and also increasing the volume of transit cargo.`,

      p_2: `The State Enterprise "Turkmenulaggozegchilik" carries out the following activities, related to the increase in 
              the capacity of international transport corridors in the transport sector of Turkmenistan, the regular organization 
              of freight traffic and the organizational implementation of these activities:`,

      li_1: `Control over the safety of cargo transportation;`,
      li_2: `Control over the safe transportation of passengers and ensuring a high culture of their service;`,
      li_3: `Provision of parking and technical services to interested persons and carriers;`,
      li_4: `Control over the monitoring compliance with the requirements of the legislation on the transportation of goods and licensing of transport and forward activities;`,
      li_5: `Provision of services for the technical inspection of vehicles;`,
      li_6: `Carrying out inspections, providing practical and methodological assistance to automotive companies on the basis of instructions from the founder;`,
      li_7: `In order to compensate for the costs, associated with the implementation of transport control, in export-import and transit freight traffic, 
              logistics, tariff, technical and other issues, it is advisable to use the benefits, provided by the legislation of Turkmenistan, and also 
              maintain production, farming and other enterprises;`,
      li_8: `Consideration, analysis and adoption of appropriate decisions on the collection of documents for the registration of vehicles and trailers for 
              individuals and legal entities, in order to conduct inspections and certification activities;`,
      li_9: `Control over the monitoring compliance with the relevant legal acts according to the plan, which is annually approved by a tripartite 
              agreement with authorized enterprises, institutions and organizations;`,
      li_10: `Development of technical conditions and methods for providing services in the field of registration, testing and certification of 
              vehicles permitted to participate in road traffic and ensure road safety;`,
      li_11: `Development of mandatory rules for the organization and implementation of freight traffic, and control over their observance;`,
      li_12: `Development of special rules of the road and the establishment of security measures for their implementation;`,
      li_13: `Collection, compilation and analysis of information on the activities of freight traffic;`,
      li_14: `Implementation of other powers in accordance with the normative legal acts of Turkmenistan.`,
    },

    online_application_navbar: {
      title: "Dashboard",

      individual: "Individual",
      legal: "Legal entity",
      drivers: "Drivers",
      cars: "Cars",
      traits: "Trailers",
      request_to_permit: "Request for permit",

      load_permission_tab:
        "Permission for international transportation (for loading)",
      unload_permission_tab:
        "Permission for international transportation (for unloading)",
      online_application_tab: "Application for CMR",
      change_password_tab: "Change password",
      logout: "Log out",
    },

    initial_tab: {
      title: "Online request",
      dashboard: "Dashboard",
      load_permission:
        "Permission for international transportation (for loading)",
      unload_permission:
        "Permission for international transportation (for unloading)",
      online_application: "Application for CMR",
    },

    profile_tab: {
      profile_data: "Profile data",
      family_name: "Surname and name",
      phone: "Phone *",
      institution_data: "Institution data",
      institution_name: "Institution name",
      cert_id: "Certificate id and validity period",
      yegrpo:
        "Unified State Register of Legal Entities of Turkmenistan (ÝEGRPO):",
      save_button: "Save",

      success: {
        title: "Data updated",
        message: "Your data has been updated successfully",
        buttonText: "OK",
      },
      failure: {
        title: "Data not updated",
        message: "Error occured while updating your data",
        buttonText: "OK",
      },
    },

    company_data: {
      individual_title: "Individual",
      surname: "Surname",
      name: "Name",
      patronymic: "Patronymic",
      tel: "Phone",
      patent: "Patent",
      licenseNumb: "License number",
      licenseCodes: "License code",
      select_region: "Choose region:",
      select_city: "Choose city:",
      license_expire_date: "License expiration date",
      patent_number: "Patent number",
      patent_expire_date: "Patent expiration date",
      license: "License",

      legal_title: "Legal entity",
      company_name: "Organization name",
      egrepo_number: "USREO (ЕГРПО) number",
      egrepo_expire_date: "USREO (ЕГРПО) expiration date",
      sertificate_number: "Sertificate number",
      address: "Legal address",
      bank_info: "Bank information",
      bank_account_number: "Bank account number",
      bank_balance: "Bank account balance",
      egrepo: "USREO (ЕГРПО)",
      certificate: "Sertificate",
    },

    driver_tab: {
      driver_list: "Drivers information",
      driver_add: " Add driver",
      surname: "Surname",
      name: "Name",
      patronymic: "Patronymic",
      driving_license_number: "Drivers license number",
      driving_license_category: "Drivers license category",
      driving_license_expire_date: "Drivers license expiration date",
      transports: "Transports",
      trait: "Traits",
    },

    car_tab: {
      car_list: "Cars information",
      car_add: "Add car",
      car_brand: "Car brand",
      car_number: "Car number",

      card_number: "Card number",
      card_star_date: "Card issue date",
      select_driver: "Choose driver",
    },

    trailer_tab: {
      trailer_title: "Trailers information",
      trailer_add: "Add trailer",
      trailer_brand: "Trailer brand",
      trailer_number: "Trailer number",
    },

    e_permit_tab: {
      permit_history: "Permit history",
      permit_type: "Trip type",
      permit_add: "Create a request",
      to_country: "Destination country",
      departure_date: "Departure date",
      return_date: "Return date",
      status: "Status",
      payment: "Payment",
      statusType: {
        1: "New",
        2: "Under consideration",
        3: "To pay",
        4: "Paid",
        5: "Successfully",
        6: "Rejected",
      },

      car: "Car",
      trailer: "Trait",
      individual: "Individual",
      legal: "Legal entity",
      select_country: "Choose destination country",
      type_of_cargo: "Cargo type",
      container_number: "Amount of containers",
      select_car: "Choose car",
      select_trailer: "Select a trailer",
    },

    load_permission_tab: {
      title: "Permission for international transportation <br/>(for loading)",
      permission_id: "Permission №",
      car_brand: "Vehicle brand",
      transporter_name: "Surname, name, patronymic of the carrier",
      unloading_point: "Vehicle unloading point",
      cargo_type: "Name and weight of cargo",
      applicant_name: "Applicant name",
      permission_issued: "Place of issue and date",
      car_state_affiliation: "State affiliation of the vehicle",
      car_state_id: "State motor of vehicle",
      loading_point: "Vehicle loading point",
      cargo_route: "The route of the cargo",
      cargo_ownership: "Cargo ownership",
      expiration_date: "Validity period of the permission",
      cmr_id: "CMR №",
      save_button: "Save",

      success: {
        title: "Thank you",
        message:
          "Your application accepted. Our administrators will contact you.",
        buttonText: "OK",
      },
      failure: {
        title: "Error",
        message: "Error has occured",
        buttonText: "OK",
      },
    },

    unload_permission_tab: {
      title: "Permission for international transportation<br/> (for unloading)",
    },

    online_application_tab: {
      online_application: "Online application",
      institution_name: "Institution name",
      load_permission_id:
        "Id of permission for loading cargo on the territory of Turkmenistan",
      cmr_id: "Transport document CMR (quantity)",
      submit_button: "Confirm",

      responsible: {
        title: "Responsible employee",
        name: "Surname and name of responsible employee:",
        phone: "Phone of responsible employee:",
        email: "E-mail of responsible employee:",
        director_name: "Surname and name of director of institution:",
      },

      additional_notes: {
        title: "Additional notes",
        file_1_desc: "Upload the copy of application letter",
        file_2_desc: `Upload a copy of the license for organizing the transportation of goods by road, 
                        freight forwarding (transportation) activities on the basis of the subspecies Transport 
                        and forwarding activities "- 52.29.22`,
        file_3_desc:
          "Unified State Register of Legal Entities of Turkmenistan (ÝEGRPO)",
        attach_file: "Attach file",
      },

      video: {
        title:
          "Watch the video below to learn how to submit an online application",
        watch_button: "Watch video",
      },

      pdf: {
        title: "Download the copy of application letter",
        download_button: "Download PDF",
      },

      success: {
        title: "Thank you",
        message:
          "Your application accepted. Our administrators will contact you.",
        buttonText: "OK",
      },
      failure: {
        title: "Error",
        message: "Error has occured",
        buttonText: "OK",
      },
      unsupportedFormat: {
        title: "Error",
        message: "Current file format not supported",
        buttonText: "OK",
      },

      fileSizeExceeded: {
        title: "Error",
        message: "Too Large File",
        buttonText: "OK",
      },
    },

    history_tab: {
      title: "Applications' history",
      permission_number: "Permission №",
      date: "Date",
      type: "Application",
      status: "Status",
      cancel: "Cancel",
      pending: "Pending",
      accepted: "Accepted",
      declined: "Declined",
      canceled: "Canceled",
      driver_name: "Driver Name",

      success: {
        title: "Data updated",
        message: "Your data has been updated successfully",
        buttonText: "OK",
      },
      failure: {
        title: "Data not updated",
        message: "Error occured while updating your data",
        buttonText: "OK",
      },
    },

    change_password_tab: {
      title: "Change Password",
      old_password: "Old password",
      new_password: "Password",
      password_confirmation: "Password confirmation",
      submit_button: "Confirm",
    },

    single_news_page: {
      similar_news: "Similar news",
    },

    login_page: {
      title: "Login",
      password: "Password",
      no_account: "Don't have an account?",
      signup: "Sign up",
      submit_button: "Login",
      forgot_password: "Forgot password?",
      invalid_creds: "Invalid data",
    },

    signup_page: {
      title: "Sign Up",
      responsible_empl: "Responsible employee",
      name: "Surname and name",
      phone: "Phone",
      accept_privacy_policy1: "I accept the terms of the",
      accept_privacy_policy2: "Privacy Policy",
      institution_name: "Institution name",
      cert_id: "Certificate id and validity period",
      yegrpo:
        "Unified State Register of Legal Entities of Turkmenistan (ÝEGRPO):",
      submit_button: "Sign Up",

      confirmation_tab: {
        message_sent:
          "An email with a confirmation code has been sent to your email address",
        conf_number: "Confirmation code",
        submit_button: "Submit",
      },

      password_tab: {
        title: "Sign Up",
        password: "Password",
        password_conf: "Password confirmation",
        submit_button: "Save",
      },

      success: {
        title: "User Created",
        message: "New user has been created successfully",
        buttonText: "OK",
      },
      failure: {
        title: "Error",
        message: "Error has occured",
        buttonText: "OK",
      },
    },

    reset_page: {
      title: "Password Reset",

      tab_1: {
        title: "Enter your email",
        confirm: "Confirm",
        info_text:
          "An email with a password reset link has been sent to your email address.",
      },
      tab_2: {
        title: "Change password",
        new_password: "New password",
        password_conf: "Password confirmation",
        confirm: "Confirm",
      },

      failure: {
        title: "Error",
        message: "Error has occured, please check your data",
        invalid_link: "Link has expired",
        buttonText: "OK",
      },

      success: {
        title: "Password Updated",
        message: "Your password has been successfully updated",
        buttonText: "OK",
      },
    },

    not_found_page: {
      title: "404 Page Not Found",
    },
  },
};

export default messages;
